/* import __COLOCATED_TEMPLATE__ from './section-vertical.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();